import React from "react";
import { Space } from "antd";
import { AxModal, AxButton, AxDivider } from "@dynata/axiom3";

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }
  render() {
    return (
      <div className="section" id="modal">
        <h3>Modal</h3>
        <p>Modal dialogs.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>{`<AxButton onClick={() => this.setState({ isVisible: true })}>
  Show Modal
</AxButton>
<AxModal
  visible={this.state.isVisible}
  onCancel={() => this.setState({ isVisible: false })}
  title="Basic Modal"
  footer={
    <div>
      <AxButton
        onClick={() => this.setState({ isVisible: false })}
        color="blue"
        type="secondary"
        size="large"
      >
        Cancel
      </AxButton>
      <AxButton
        onClick={() => this.setState({ isVisible: false })}
        color="blue"
        size="large"
      >
        Ok
      </AxButton>
    </div>
  }
>
  <p>
    Sit amet, consectetur adipiscing elit, sed do eiusmod tempor
    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
  </p>
</AxModal>`}</pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>afterClose</td>
                <td>
                  Specify a function that will be called when modal is closed
                  completely
                </td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>bodyStyle</td>
                <td>
                  Body style for modal body element. Such as height, padding etc
                </td>
                <td>CSSProperties</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>cancelButtonProps</td>
                <td>The cancel button props</td>
                <td>
                  <a href="/components/button/#API">ButtonProps</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>cancelText</td>
                <td>Text of the Cancel button</td>
                <td>ReactNode</td>
                <td>
                  <code>Cancel</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>centered</td>
                <td>Centered Modal</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>closable</td>
                <td>
                  Whether a close (x) button is visible on top right of the
                  modal dialog or not
                </td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>closeIcon</td>
                <td>Custom close icon</td>
                <td>ReactNode</td>
                <td>&lt;CloseOutlined /&gt;</td>
                <td></td>
              </tr>
              <tr>
                <td>confirmLoading</td>
                <td>
                  Whether to apply loading visual effect for OK button or not
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>destroyOnClose</td>
                <td>Whether to unmount child components on onClose</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>focusTriggerAfterClose</td>
                <td>
                  Whether need to focus trigger element after dialog is closed
                </td>
                <td>boolean</td>
                <td>true</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>footer</td>
                <td>
                  Footer content, set as <code>footer={null}</code> when you
                  don't need default buttons
                </td>
                <td>ReactNode</td>
                <td>(OK and Cancel buttons)</td>
                <td></td>
              </tr>
              <tr>
                <td>forceRender</td>
                <td>Force render Modal</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>getContainer</td>
                <td>
                  The mounted node for Modal but still display at fullscreen
                </td>
                <td>HTMLElement | () =&gt; HTMLElement | Selectors | false</td>
                <td>document.body</td>
                <td></td>
              </tr>
              <tr>
                <td>keyboard</td>
                <td>Whether support press esc to close</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>mask</td>
                <td>Whether show mask or not</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>maskClosable</td>
                <td>
                  Whether to close the modal dialog when the mask (area outside
                  the modal) is clicked
                </td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>maskStyle</td>
                <td>Style for modal's mask element</td>
                <td>CSSProperties</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>modalRender</td>
                <td>Custom modal content render</td>
                <td>(node: ReactNode) =&gt; ReactNode</td>
                <td>-</td>
                <td>4.7.0</td>
              </tr>
              <tr>
                <td>okButtonProps</td>
                <td>The ok button props</td>
                <td>
                  <a href="/components/button/#API">ButtonProps</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>okText</td>
                <td>Text of the OK button</td>
                <td>ReactNode</td>
                <td>
                  <code>OK</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>okType</td>
                <td>
                  Button <code>type</code> of the OK button
                </td>
                <td>string</td>
                <td>
                  <code>primary</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>style</td>
                <td>
                  Style of floating layer, typically used at least for adjusting
                  the position
                </td>
                <td>CSSProperties</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>title</td>
                <td>The modal dialog's title</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>open</td>
                <td>
                  Whether the modal dialog is visible or not. Use{" "}
                  <code>visible</code> under 4.23.0 (
                  <a href="/docs/react/faq#why-open">why?</a>)
                </td>
                <td>boolean</td>
                <td>false</td>
                <td>4.23.0</td>
              </tr>
              <tr>
                <td>width</td>
                <td>Width of the modal dialog</td>
                <td>string | number</td>
                <td>520</td>
                <td></td>
              </tr>
              <tr>
                <td>wrapClassName</td>
                <td>The class name of the container of the modal dialog</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>zIndex</td>
                <td>
                  The <code>z-index</code> of the Modal
                </td>
                <td>number</td>
                <td>1000</td>
                <td></td>
              </tr>
              <tr>
                <td>onCancel</td>
                <td>
                  Specify a function that will be called when a user clicks
                  mask, close button on top right or Cancel button
                </td>
                <td>function(e)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onOk</td>
                <td>
                  Specify a function that will be called when a user clicks the
                  OK button
                </td>
                <td>function(e)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to the{" "}
                  <>
                    <AxButton
                      size="small"
                      type="link"
                      target="_blank"
                      href="https://4x.ant.design/components/modal/#API"
                    >
                      {`<Modal />`}
                    </AxButton>
                  </>{" "}
                  component.
                </td>
                <td></td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div className="prop-header">
            <p className="props-title">Note</p>
          </div>
          <ul>
            <li>
              <p>
                The state of Modal will be preserved at it's component lifecycle
                by default, if you wish to open it with a brand new state
                everytime, set <code>destroyOnClose</code> on it.
              </p>
            </li>
            <li>
              <p>
                There is a situation that using <code>&lt;Modal /&gt;</code>{" "}
                with Form, which won't clear fields value when closing Modal
                even you have set <code>destroyOnClose</code>. You need{" "}
                <code>&lt;Form preserve={false} /&gt;</code> in this case.
              </p>
            </li>
            <li>
              <p>
                <code>Modal.method()</code> RTL mode only supports hooks.
              </p>
            </li>
          </ul>

          <div className="prop-header">
            <p className="props-title">Modal.method()</p>
          </div>

          <p>
            There are five ways to display the information based on the
            content's nature:
          </p>
          <ul>
            <li>
              <p>
                <code>Modal.info</code>
              </p>
            </li>
            <li>
              <p>
                <code>Modal.success</code>
              </p>
            </li>
            <li>
              <p>
                <code>Modal.error</code>
              </p>
            </li>
            <li>
              <p>
                <code>Modal.warning</code>
              </p>
            </li>
            <li>
              <p>
                <code>Modal.confirm</code>
              </p>
            </li>
          </ul>
          <p>
            The items listed above are all functions, expecting a settings
            object as parameter. The properties of the object are follows:
          </p>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>afterClose</td>
                <td>
                  Specify a function that will be called when modal is closed
                  completely
                </td>
                <td>function</td>
                <td>-</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>autoFocusButton</td>
                <td>Specify which button to autofocus</td>
                <td>
                  null | <code>ok</code> | <code>cancel</code>
                </td>
                <td>
                  <code>ok</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>bodyStyle</td>
                <td>
                  Body style for modal body element. Such as height, padding etc
                </td>
                <td>CSSProperties</td>
                <td></td>
                <td>4.8.0</td>
              </tr>
              <tr>
                <td>cancelButtonProps</td>
                <td>The cancel button props</td>
                <td>
                  <a href="/components/button/#API">ButtonProps</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>cancelText</td>
                <td>Text of the Cancel button with Modal.confirm</td>
                <td>string</td>
                <td>
                  <code>Cancel</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>centered</td>
                <td>Centered Modal</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>className</td>
                <td>The className of container</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>closable</td>
                <td>
                  Whether a close (x) button is visible on top right of the
                  confirm dialog or not
                </td>
                <td>boolean</td>
                <td>false</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>closeIcon</td>
                <td>Custom close icon</td>
                <td>ReactNode</td>
                <td>undefined</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>content</td>
                <td>Content</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>getContainer</td>
                <td>Return the mount node for Modal</td>
                <td>HTMLElement | () =&gt; HTMLElement | Selectors | false</td>
                <td>document.body</td>
                <td></td>
              </tr>
              <tr>
                <td>icon</td>
                <td>Custom icon</td>
                <td>ReactNode</td>
                <td>&lt;QuestionCircle /&gt;</td>
                <td></td>
              </tr>
              <tr>
                <td>keyboard</td>
                <td>Whether support press esc to close</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>mask</td>
                <td>Whether show mask or not.</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>maskClosable</td>
                <td>
                  Whether to close the modal dialog when the mask (area outside
                  the modal) is clicked
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>maskStyle</td>
                <td>Style for modal's mask element</td>
                <td>object</td>
                <td>{}</td>
                <td></td>
              </tr>
              <tr>
                <td>okButtonProps</td>
                <td>The ok button props</td>
                <td>
                  <a href="/components/button/#API">ButtonProps</a>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>okText</td>
                <td>Text of the OK button</td>
                <td>string</td>
                <td>
                  <code>OK</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>okType</td>
                <td>
                  Button <code>type</code> of the OK button
                </td>
                <td>string</td>
                <td>
                  <code>primary</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>style</td>
                <td>
                  Style of floating layer, typically used at least for adjusting
                  the position
                </td>
                <td>CSSProperties</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>title</td>
                <td>Title</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>width</td>
                <td>Width of the modal dialog</td>
                <td>string | number</td>
                <td>416</td>
                <td></td>
              </tr>
              <tr>
                <td>wrapClassName</td>
                <td>The class name of the container of the modal dialog</td>
                <td>string</td>
                <td>-</td>
                <td>4.18.0</td>
              </tr>
              <tr>
                <td>zIndex</td>
                <td>
                  The <code>z-index</code> of the Modal
                </td>
                <td>number</td>
                <td>1000</td>
                <td></td>
              </tr>
              <tr>
                <td>onCancel</td>
                <td>
                  Specify a function that will be called when the user clicks
                  the Cancel button. The parameter of this function is a
                  function whose execution should include closing the dialog. If
                  the function does not take any parameter (
                  <code>!onCancel.length</code>) then modal dialog will be
                  closed unless returned value is <code>true</code> (
                  <code>!!onCancel()</code>). You can also just return a promise
                  and when the promise is resolved, the modal dialog will also
                  be closed
                </td>
                <td>function(close)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onOk</td>
                <td>
                  Specify a function that will be called when the user clicks
                  the OK button. The parameter of this function is a function
                  whose execution should include closing the dialog. If the
                  function does not take any parameter (
                  <code>!onOk.length</code>) then modal dialog will be closed
                  unless returned value is <code>true</code> (
                  <code>!!onOk()</code>). You can also just return a promise and
                  when the promise is resolved, the modal dialog will also be
                  closed
                </td>
                <td>function(close)</td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <Space size="large">
          <AxButton onClick={() => this.setState({ isVisible: true })}>
            Show Modal
          </AxButton>
          <AxModal
            visible={this.state.isVisible}
            onCancel={() => this.setState({ isVisible: false })}
            title="Basic Modal"
            footer={
              <div>
                <AxButton
                  onClick={() => this.setState({ isVisible: false })}
                  color="blue"
                  type="secondary"
                  size="large"
                >
                  Cancel
                </AxButton>
                <AxButton
                  onClick={() => this.setState({ isVisible: false })}
                  color="blue"
                  size="large"
                >
                  Ok
                </AxButton>
              </div>
            }
          >
            <p>
              Sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
            </p>
          </AxModal>
        </Space>

        <AxDivider orientation="left" plain>
          Custom Header
        </AxDivider>

        <Space direction="vertical" size={40}>
          <AxButton onClick={() => this.setState({ isVisible: true })}>
            Custom Header
          </AxButton>
          <AxModal
            visible={this.state.isVisible}
            onCancel={() => this.setState({ isVisible: false })}
            wrapClassName="custom-header"
            title={
              <div style={{ background: "#1B365D" }}>
                Axiom Design System is essentially a UI component library for
                ReactJS applications. It is built on top of AntDesign where each
                Axiom component is extended from one or more AntDesign
                components. Axiom components share most of the props from
                AntDesign along with some extra props of their own, which are
                defined in detail in their respective sections, below.
              </div>
            }
            footer={
              <div>
                <AxButton
                  onClick={() => this.setState({ isVisible: false })}
                  color="blue"
                  type="secondary"
                  size="large"
                >
                  Cancel
                </AxButton>
                <AxButton
                  onClick={() => this.setState({ isVisible: false })}
                  color="blue"
                  size="large"
                >
                  Ok
                </AxButton>
              </div>
            }
          >
            <p>
              Sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
            </p>
          </AxModal>

          <pre>{`<AxButton onClick={() => this.setState({ isVisible: true })}>
Custom Header
</AxButton>
<AxModal
  visible={this.state.isVisible}
  onCancel={() => this.setState({ isVisible: false })}
  wrapClassName="custom-header"
  title={
    <div style={{ background: "#1B365D" }}>
      Axiom Design System is essentially a UI component library for
      ReactJS applications. It is built on top of AntDesign where each
      Axiom component is extended from one or more AntDesign
      components. Axiom components share most of the props from
      AntDesign along with some extra props of their own, which are
      defined in detail in their respective sections, below.
    </div>
  }
  footer={
    <div>
      <AxButton
        onClick={() => this.setState({ isVisible: false })}
        color="blue"
        type="secondary"
        size="large"
      >
        Cancel
      </AxButton>
      <AxButton
        onClick={() => this.setState({ isVisible: false })}
        color="blue"
        size="large"
      >
        Ok
      </AxButton>
    </div>
  }
>
  <p>
    Sit amet, consectetur adipiscing elit, sed do eiusmod tempor
    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
  </p>
</AxModal>`}</pre>
        </Space>

        <AxDivider orientation="left" plain>
          Info | Success | Error | Warning
        </AxDivider>

        <Space size="large">
          <AxButton
            type="primary"
            onClick={() => {
              AxModal.show({
                title: "This is a notification message",
                type: "info",
                content: (
                  <div>
                    <p>Sit amet, consectetur adipiscing elit.</p>
                  </div>
                ),
              });
            }}
          >
            Info
          </AxButton>

          <AxButton
            type="primary"
            onClick={() => {
              AxModal.show({
                type: "success",
                content: "Sit amet, consectetur adipiscing elit.",
              });
            }}
          >
            Success
          </AxButton>

          <AxButton
            type="primary"
            onClick={() => {
              AxModal.show({
                type: "error",
                title: "This is an error message",
                content: "Sit amet, consectetur adipiscing elit.",
              });
            }}
          >
            Error
          </AxButton>

          <AxButton
            type="primary"
            onClick={() => {
              AxModal.show({
                type: "warning",
                title: "This is a warning message",
                content: "Sit amet, consectetur adipiscing elit.",
              });
            }}
          >
            Warning
          </AxButton>
        </Space>
      </div>
    );
  }
}
export default Modal;
